// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-input{position:relative}.form-input input{width:100%;padding:1rem 2.667rem 1rem 1.333rem;background-color:transparent;border:2px solid #003d4c}.form-input .input-dark{border-width:1px;--tw-border-opacity:1;border-color:rgba(0,0,0,var(--tw-border-opacity))}.form-input__close{position:absolute;right:20px;top:calc(50% - 11px)}", ""]);
// Exports
module.exports = exports;
